import { render, staticRenderFns } from "./SaleInvoiceTemplateOne.vue?vue&type=template&id=20d69dfe&"
import script from "./SaleInvoiceTemplateOne.vue?vue&type=script&lang=js&"
export * from "./SaleInvoiceTemplateOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports